<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>物流管理</el-breadcrumb-item>
			<el-breadcrumb-item>自提点管理</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="自提点名称">
				<el-input v-model="item.title" placeholder="请输入自提点名称" size="small"></el-input>
			</el-form-item>
			<el-form-item label="联系人">
				<el-input v-model="item.name" placeholder="请输入联系人" size="small"></el-input>
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input v-model="item.mobile" placeholder="请输入手机号码" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add">添加自提点</el-button>
			<el-button type="danger" size="small" @click="delAll">批量删除</el-button>
		</div>


		<!--		数据是list 通过list展示-->
		<el-table :data="list" @selection-change="handleSelectionChange" border>
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="title" label="自提点名称"></el-table-column>
			<el-table-column prop="name" label="联系人"></el-table-column>
			<el-table-column prop="mobile" label="手机号码"></el-table-column>
			<el-table-column prop="address" label="地址"></el-table-column>
			<el-table-column prop="created_date" label="创建时间"></el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {}
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadList()
		},
		methods: {
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/admin/setting/pickList', this.item).then(res => {
					this.isLoad = !this.isLoad
					// 获取数据
					this.list = res.data.records
					// 页数 page
					this.total = res.data.total
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Logistics/pickUpEdit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Logistics/pickUpEdit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/setting/pickDel', {
						data: [
							id
						]
					})
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/setting/pickDel', {
						data: id
					}).then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
